import { useState, useEffect } from 'react';
import { tenant as tenantApi } from '../services/api';

export default function Canales({ permisos }) {
  const [form, setForm] = useState({
    whatsapp_phone_id: '',
    whatsapp_token: '',
    whatsapp_verify_token: '',
    whatsapp_cta_numero: '',
    _whatsapp_ok: false,
  });
  const [data, setData]       = useState(null);
  const [saving, setSaving]   = useState(false);
  const [msg, setMsg]         = useState('');
  const [copied, setCopied]   = useState('');

  useEffect(() => {
    tenantApi.getMe().then(d => {
      setData(d);
      setForm(f => ({
        ...f,
        whatsapp_phone_id:     d.whatsapp_phone_id     || '',
        whatsapp_verify_token: d.whatsapp_verify_token || '',
        whatsapp_cta_numero:   d.whatsapp_cta_numero   || '',
        _whatsapp_ok:          !!d.whatsapp_configurado,
      }));
    });
  }, []);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const copy = (text, key) => {
    navigator.clipboard.writeText(text);
    setCopied(key);
    setTimeout(() => setCopied(''), 1500);
  };

  const handleSave = async () => {
    setSaving(true);
    setMsg('');
    const payload = {
      whatsapp_phone_id:     form.whatsapp_phone_id,
      whatsapp_verify_token: form.whatsapp_verify_token,
      whatsapp_cta_numero:   form.whatsapp_cta_numero,
    };
    if (form.whatsapp_token) payload.whatsapp_token = form.whatsapp_token;
    const res = await tenantApi.update(payload);
    if (res.status === 'ok') setMsg('✓ Cambios guardados correctamente');
    else setMsg('✗ Error al guardar');
    setSaving(false);
    setTimeout(() => setMsg(''), 3000);
  };

  if (!data) return <div className="content" style={{ color: 'var(--text3)' }}>Cargando...</div>;

  const webhooks = [
    { label: 'WhatsApp Webhook',  url: data.webhook_whatsapp, key: 'wa', note: 'Meta → WhatsApp → Webhooks' },
    { label: 'Messenger Webhook', url: `https://bot.devit.es/api/meta/messenger/${data.tenant_id}`, key: 'ms', note: 'Meta → Messenger → Webhooks' },
    { label: 'Instagram Webhook', url: `https://bot.devit.es/api/meta/instagram/${data.tenant_id}`, key: 'ig', note: 'Meta → Instagram → Webhooks' },
  ];

  return (
    <div>
      <div className="topbar">
        <div>
          <div className="page-title">Canales</div>
          <div className="page-sub">WhatsApp, Messenger e Instagram</div>
        </div>
      </div>
      <div className="content">

        {/* ── WhatsApp ── */}
        <div className="card" style={{ marginBottom: '16px' }}>
          <div className="card-title">WhatsApp Business API</div>
          {form._whatsapp_ok && (
            <div className="alert alert-success" style={{ marginBottom: '12px' }}>
              <span className="alert-icon">✓</span> WhatsApp activo y recibiendo mensajes.
            </div>
          )}
          <div className="form-group">
            <label className="form-label">
              Phone Number ID
              {form._whatsapp_ok && <span style={{ marginLeft: 8, color: 'var(--green)', fontSize: 10 }}>✓ configurado</span>}
            </label>
            <input className="form-input" placeholder="123456789012345"
              value={form.whatsapp_phone_id} onChange={e => set('whatsapp_phone_id', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">
              Access Token
              {form._whatsapp_ok && <span style={{ marginLeft: 8, color: 'var(--green)', fontSize: 10 }}>✓ configurado</span>}
            </label>
            <input className="form-input masked" type="password"
              placeholder="EAAxxxxxxx — dejar vacío para mantener el actual"
              value={form.whatsapp_token} onChange={e => set('whatsapp_token', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">
              Verify Token
              <span style={{ fontSize: 10, color: 'var(--text3)', marginLeft: 6 }}>(WhatsApp, Messenger e Instagram)</span>
            </label>
            <input className="form-input" placeholder="devit_verify_2026"
              value={form.whatsapp_verify_token} onChange={e => set('whatsapp_verify_token', e.target.value)} />
            <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 4 }}>
              Usa este mismo token en Meta para los tres canales
            </div>
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label">📲 Número WhatsApp para CTA en publicaciones</label>
            <input className="form-input" placeholder="34600111222 — sin + ni espacios"
              value={form.whatsapp_cta_numero} onChange={e => set('whatsapp_cta_numero', e.target.value)} />
            {form.whatsapp_cta_numero && (
              <div style={{ fontSize: 10, color: 'var(--accent)', marginTop: 4 }}>
                → wa.me/{form.whatsapp_cta_numero}
              </div>
            )}
          </div>
        </div>

        {/* ── URLs de Webhook ── */}
        <div className="card" style={{ marginBottom: '16px' }}>
          <div className="card-title">URLs de Webhook</div>
          <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12 }}>
            Pega estas URLs en Meta Developer → Webhooks junto con el Verify Token de arriba.
          </div>
          {webhooks.map(({ label, url, key, note }) => (
            <div className="url-block" key={key} style={{ marginBottom: 10 }}>
              <div className="url-label">{label}</div>
              <div className="url-row">
                <span className="url-text">{url || 'Cargando...'}</span>
                {url && (
                  <button className="copy-btn" onClick={() => copy(url, key)}>
                    {copied === key ? '✓' : '⎘'}
                  </button>
                )}
              </div>
              <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 4 }}>{note}</div>
            </div>
          ))}
          {data?.verify_token && (
            <div style={{ marginTop: 8, paddingTop: 12, borderTop: '1px solid var(--border)' }}>
              <div className="url-label">Token de verificación activo</div>
              <div className="url-row">
                <span className="url-text" style={{ color: 'var(--amber)' }}>{data.verify_token}</span>
                <button className="copy-btn" onClick={() => copy(data.verify_token, 'vt')}>
                  {copied === 'vt' ? '✓' : '⎘'}
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="divider"></div>
        {msg && (
          <div className={`alert ${msg.startsWith('✓') ? 'alert-success' : 'alert-warn'}`} style={{ marginBottom: 12 }}>
            {msg}
          </div>
        )}
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Guardando...' : '✓ Guardar cambios'}
          </button>
          <button className="btn btn-ghost" onClick={() => window.location.reload()}>Descartar</button>
        </div>
      </div>
    </div>
  );
}
